import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { TablerIcon } from '@rossum/ui/icons/tabler';
import { Link, Stack, SvgIcon } from '@rossum/ui/material';
import { LocalizationKeys } from '../../../i18n';
import { StatCard } from './StatCard';

export type StatsType = {
  Icon: TablerIcon;
  title: LocalizationKeys;
  value: string | number;
  type: string;
  link?: string;
};

type Props = {
  stats: StatsType[];
};

const Stats = ({ stats }: Props) => {
  const intl = useIntl();
  return (
    <>
      {stats.map(({ Icon, title, value, type, link }) => (
        <Stack key={title} sx={{ flexGrow: 1, flexBasis: '30%' }}>
          <StatCard
            icon={
              <SvgIcon fontSize="large" color="primary">
                <Icon />
              </SvgIcon>
            }
            title={`${value} ${intl.formatMessage(
              {
                id: title,
              },
              { count: value }
            )}`}
            titleDataCy={`stats-value-${type}`}
            description={
              link && (
                <Link
                  component={RouterLink}
                  variant="caption"
                  to={link}
                  color="text.disabled"
                  sx={{
                    textDecorationColor: 'text.disabled',
                    '&:hover': {
                      color: 'text.disabled',
                      textDecoration: 'none',
                    },
                  }}
                >
                  {intl.formatMessage({
                    id: 'containers.settings.queues.engine.linkMore',
                  })}
                </Link>
              )
            }
          />
        </Stack>
      ))}
    </>
  );
};

export default Stats;
